module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-04-735501011fb34a904de1bb7ce0ee8c89.jpg";